import { render } from "./map-page.vue?vue&type=template&id=63d3caa9&scoped=true"
import script from "./map-page.vue?vue&type=script&lang=js"
export * from "./map-page.vue?vue&type=script&lang=js"

import "./map-page.vue?vue&type=style&index=0&id=63d3caa9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d3caa9"]])

export default __exports__